import { ValidationError } from '@/utils/index';

export const ERRORS_TEMPLATES = {
  INCORRECT_CODE: 'incorrect_code',
};

export const isErrorTemplate = (e: unknown, errorTemplate: string) => {
  if (!(e instanceof ValidationError)) return false;
  return Boolean(
    e.fieldErrors.find(
      ({ messageTemplate }) => messageTemplate === errorTemplate,
    ),
  );
};
